import SkeletonTableData from "./skeleton-table-data";

import './skeleton.scss';

const SkeletonCustom = {
    TableData : SkeletonTableData
};

export default SkeletonCustom;
